import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocality, useVillageFilter } from "../../../API_Master/FetchAPI";
import FilterButtons from "../../../CommonComponents/FilterButtons";
import Loader from "../../../CommonComponents/Loader";
import { CMFormDropDown, CMFormInput } from "../../../MethodMaster/JSXComponentMothod";
import { toggleOffcanvasStatus } from "../../../Redux/Slices/ProjectSlice";

const FilterMemberList = ({ filterStatus, setFilterStatus, filterRef, filterData, setFilterData, selectedVidhanSabha }) => {
  const dispatch = useDispatch();

  const [modelFilter, setModelFilter] = useState({
    mobileNo: "",
    gender: "",
    name: "",
    locality: "",
    village: "",
    idCardNo: "",
    outside: "",
    handicap: "",
  });

  const { data: LocalityData = [], isFetching: isLocalityFetching } = useLocality(modelFilter.village ? true : false, modelFilter.village, null, selectedVidhanSabha);
  const { data: VillageData = [], isFetching: isVillageFetching } = useVillageFilter(true, filterStatus, null, selectedVidhanSabha);

  useEffect(() => {
    if (filterStatus) {
      setModelFilter({
        mobileNo: filterData?.mobileNo || "",
        gender: filterData?.gender || "",
        name: filterData?.name || "",
        locality: filterData?.locality || "",
        village: filterData?.village || "",
        idCardNo: filterData?.idCardNo || "",
        outside: filterData?.outside || "",
        handicap: filterData?.handicap || "",
      });
    }
  }, [filterStatus]);

  const handleFilterChange = (e) => {
    setModelFilter((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleFilterClose = () => {
    setFilterStatus(false);
    dispatch(toggleOffcanvasStatus(false));
  };

  const handleFilterSelectChange = (e, name) => {
    setModelFilter((prev) => {
      const updated = {
        ...prev,
        [name]: e.value,
      };

      if (name === "village") {
        updated.locality = "";
      }

      return updated;
    });
  };

  const handleFilterSearch = () => {
    setFilterStatus(false);
    dispatch(toggleOffcanvasStatus(false));
    setFilterData(modelFilter);
  };

  const handleFilterCancle = () => {
    setFilterStatus(false);
    const cancleFilterData = {
      mobileNo: "",
      gender: "",
      name: "",
      locality: "",
      village: "",
      idCardNo: "",
      outside: "",
      handicap: "",
    };
    setModelFilter(cancleFilterData);
    setFilterData(cancleFilterData);

    dispatch(toggleOffcanvasStatus(false));
  };

  return (
    <>
      <div ref={filterRef} style={{ width: "800px" }} className={`offcanvas offcanvas-end  ${filterStatus ? " show" : "hide"}`} id="add-new-record" role="dialog">
        <div className="offcanvas-header border-bottom">
          <span className="mb-n3 text-dark filterTitleMain">Filter Member</span>
          <button onClick={handleFilterClose} className="btn-close text-reset" />
        </div>
        <div className="offcanvas-body flex-grow-1">
          <div className="add-new-record pt-0 row g-2 fv-plugins-bootstrap5 fv-plugins-framework" id="form-add-new-record" onsubmit="return false" noValidate="novalidate">
            <CMFormInput
              InputLabel={"Mobile No"}
              ColSize="col-sm-12 col-md-6 form-control-validation  mt-0  fv-plugins-icon-container"
              id={"mobileNo"}
              temptVal={modelFilter?.mobileNo}
              type={"text"}
              maxLength={10}
              handleDispatch={handleFilterChange}
            />
            <CMFormDropDown
              InputLabel={"Gender"}
              IsFormikInput={true}
              ColSize="col-sm-12 col-md-6 form-control-validation mt-0 mb-n5"
              options={[
                { label: "-- Select Gender --", value: "" },
                { label: "Male", value: "M" },
                { label: "Female", value: "F" },
              ]}
              required={true}
              id="gender"
              valueTempt={modelFilter?.gender}
              handleDispatch={(e) => handleFilterSelectChange(e, "gender")}
            />
            <CMFormInput
              InputLabel={"Name"}
              ColSize="col-sm-12 col-md-6 form-control-validation  mt-0  fv-plugins-icon-container"
              id={"name"}
              temptVal={modelFilter?.name}
              type={"text"}
              maxLength={100}
              handleDispatch={handleFilterChange}
            />
            <CMFormDropDown
              InputLabel={"Village"}
              IsFormikInput={true}
              ColSize="col-sm-12 col-md-6 form-control-validation mt-0 mb-n5"
              options={[
                { label: "-- Select village --", value: "" },
                ...VillageData?.map((element, index) => {
                  return {
                    label: element?.PartNameEnglish || "",
                    value: element?.PartNameEnglish || "",
                  };
                }),
              ]}
              required={true}
              id="village"
              valueTempt={modelFilter?.village}
              handleDispatch={(e) => {
                handleFilterSelectChange(e, "village");
              }}
            />
            <CMFormDropDown
              InputLabel={"Locality"}
              IsFormikInput={true}
              ColSize="col-sm-12 col-md-6 form-control-validation mt-0 mb-n5"
              options={[
                { label: "-- Select locality --", value: "" },
                ...LocalityData?.map((element, index) => {
                  return {
                    label: element?.LocalityEnglish || "",
                    value: element?.LocalityEnglish || "",
                  };
                }),
              ]}
              required={true}
              id="locality"
              valueTempt={modelFilter?.locality}
              handleDispatch={(e) => handleFilterSelectChange(e, "locality")}
            />
            <CMFormInput
              InputLabel={"ID Card No"}
              ColSize="col-sm-12 col-md-6 form-control-validation  mt-0  fv-plugins-icon-container"
              id={"idCardNo"}
              temptVal={modelFilter?.idCardNo}
              type={"text"}
              maxLength={100}
              handleDispatch={handleFilterChange}
            />
            <CMFormDropDown
              InputLabel={"Outside"}
              IsFormikInput={true}
              ColSize="col-sm-12 col-md-6 form-control-validation mt-0 mb-n5"
              options={[
                { label: "-- Select outside --", value: "" },
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
              ]}
              required={true}
              id="outside"
              valueTempt={modelFilter?.outside}
              handleDispatch={(e) => handleFilterSelectChange(e, "outside")}
            />
            <CMFormDropDown
              InputLabel={"Handicap"}
              IsFormikInput={true}
              ColSize="col-sm-12 col-md-6 form-control-validation mt-0 mb-n5"
              options={[
                { label: "-- Select handicap --", value: "" },
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
              ]}
              required={true}
              id="handicap"
              valueTempt={modelFilter?.handicap}
              handleDispatch={(e) => handleFilterSelectChange(e, "handicap")}
            />
          </div>
          <div className="col-sm-12 mt-2 ">
            <FilterButtons handleFilterSearch={handleFilterSearch} handleFilterCancle={handleFilterCancle} handleFilterClose={handleFilterClose} />
          </div>
        </div>
      </div>
      {(isLocalityFetching || isVillageFetching) && <Loader />}
    </>
  );
};

export default FilterMemberList;
